import React, { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

interface IframeProps {
    src: string;
    title?: string;
    width?: string;
    height?: string;
}

const Iframe = ({ src, title= '', width= '100%', height = '100%'}: IframeProps) => {
    const [isLoading, setIsLoading] = useState(true);

    const handleLoad = () => {
        setIsLoading(false);
    };

    return (
        <div style={{ position: 'relative', width, height }}>
            {isLoading && (
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <CircularProgress style={{ color: '#1DB35A' }}></CircularProgress>
                </div>
            )}
            <iframe
                src={src}
                title={title}
                width={width}
                height={height}
                onLoad={handleLoad}
                style={{display: isLoading ? 'none': 'block'}}
            />
        </div>
    );
};

export default Iframe;
